module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 90,
	"w": 544,
	"h": 302,
	"nm": "ShopVsEditorial",
	"ddd": 0,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "ABCMonumentGroteskSemi-Mono-Regular",
				"fFamily": "ABC Monument Grotesk Semi-Mono",
				"fStyle": "Regular",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 5,
			"nm": "The Shop",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						378,
						156.551,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 17,
								"f": "ABCMonumentGroteskSemi-Mono-Regular",
								"t": "The Shop",
								"j": 0,
								"tr": 0,
								"lh": 20.4,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						]
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 415,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 5,
			"nm": "Editorial content",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						52.5,
						156.551,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 17,
								"f": "ABCMonumentGroteskSemi-Mono-Regular",
								"t": "Editorial content",
								"j": 0,
								"tr": 0,
								"lh": 20.4,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						]
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 415,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "shop vs editorial Outlines 3",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						272,
						151,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						272,
						150,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-69.588,
											0
										],
										[
											0,
											69.588
										],
										[
											69.588,
											0
										],
										[
											0,
											-69.588
										]
									],
									"o": [
										[
											69.588,
											0
										],
										[
											0,
											-69.588
										],
										[
											-69.588,
											0
										],
										[
											0,
											69.588
										]
									],
									"v": [
										[
											0,
											126
										],
										[
											126,
											0
										],
										[
											0,
											-126
										],
										[
											-126,
											0
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 2",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 1,
							"ml": 5,
							"bm": 0,
							"nm": "Stroke 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									414.986,
									150.5
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 9",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-69.588,
											0
										],
										[
											0,
											69.588
										],
										[
											69.588,
											0
										],
										[
											0,
											-69.588
										]
									],
									"o": [
										[
											69.588,
											0
										],
										[
											0,
											-69.588
										],
										[
											-69.588,
											0
										],
										[
											0,
											69.588
										]
									],
									"v": [
										[
											0,
											126
										],
										[
											126,
											0
										],
										[
											0,
											-126
										],
										[
											-126,
											0
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 2",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 1,
							"ml": 5,
							"bm": 0,
							"nm": "Stroke 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									129.014,
									150.5
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 10",
					"bm": 0,
					"hd": false
				}
			],
			"ip": 0,
			"op": 415,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Mask",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						272,
						151,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						272,
						150,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-69.588,
											0
										],
										[
											0,
											69.588
										],
										[
											69.588,
											0
										],
										[
											0,
											-69.588
										]
									],
									"o": [
										[
											69.588,
											0
										],
										[
											0,
											-69.588
										],
										[
											-69.588,
											0
										],
										[
											0,
											69.588
										]
									],
									"v": [
										[
											0,
											126
										],
										[
											126,
											0
										],
										[
											0,
											-126
										],
										[
											-126,
											0
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									0,
									0,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									414.986,
									150.5
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									105,
									105
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 9",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-69.588,
											0
										],
										[
											0,
											69.588
										],
										[
											69.588,
											0
										],
										[
											0,
											-69.588
										]
									],
									"o": [
										[
											69.588,
											0
										],
										[
											0,
											-69.588
										],
										[
											-69.588,
											0
										],
										[
											0,
											69.588
										]
									],
									"v": [
										[
											0,
											126
										],
										[
											126,
											0
										],
										[
											0,
											-126
										],
										[
											-126,
											0
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									0,
									0,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									129.014,
									150.5
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									105,
									105
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 10",
					"bm": 0,
					"hd": false
				}
			],
			"ip": 0,
			"op": 415,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "shop vs editorial Outlines 2",
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 6,
							"s": [
								0
							]
						},
						{
							"t": 81,
							"s": [
								90
							]
						}
					]
				},
				"p": {
					"a": 0,
					"k": [
						272,
						151,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						272,
						150,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											6.464,
											7.161
										],
										[
											5.417,
											-7.161
										],
										[
											-6.464,
											0.906
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									140.849,
									88.262
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											25.284
										],
										[
											-8.13,
											17.962
										]
									],
									"o": [
										[
											-11.514,
											-20.608
										],
										[
											0,
											-20.998
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											9.038,
											64.271
										],
										[
											-9.038,
											-5.371
										],
										[
											3.618,
											-64.271
										]
									],
									"c": false
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									138.046,
									154.628
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-6.464,
											-7.161
										],
										[
											-5.417,
											7.161
										],
										[
											6.464,
											-0.906
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									403.151,
									211.738
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											-25.284
										],
										[
											8.13,
											-17.962
										]
									],
									"o": [
										[
											11.514,
											20.608
										],
										[
											0,
											20.998
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-9.038,
											-64.271
										],
										[
											9.038,
											5.371
										],
										[
											-3.618,
											64.271
										]
									],
									"c": false
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									405.955,
									145.372
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											7.161,
											-6.464
										],
										[
											-7.16,
											-5.417
										],
										[
											0.906,
											6.464
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									210.262,
									281.151
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											25.284,
											0
										],
										[
											17.962,
											8.13
										]
									],
									"o": [
										[
											-20.608,
											11.514
										],
										[
											-20.998,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											64.271,
											-9.038
										],
										[
											-5.371,
											9.038
										],
										[
											-64.271,
											-3.618
										]
									],
									"c": false
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									276.628,
									283.954
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 6",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-7.16,
											6.464
										],
										[
											7.161,
											5.417
										],
										[
											-0.905,
											-6.464
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									333.738,
									18.849
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 7",
					"bm": 0,
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											-25.284,
											0
										],
										[
											-17.962,
											-8.13
										]
									],
									"o": [
										[
											20.608,
											-11.514
										],
										[
											20.997,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-64.271,
											9.038
										],
										[
											5.371,
											-9.038
										],
										[
											64.271,
											3.618
										]
									],
									"c": false
								}
							},
							"nm": "Path 1",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 1",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									267.372,
									16.045
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 8",
					"bm": 0,
					"hd": false
				}
			],
			"ip": 0,
			"op": 415,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "E",
			"size": 17,
			"style": "Regular",
			"w": 60.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												54.684,
												0
											],
											[
												54.684,
												-8.157
											],
											[
												18.832,
												-8.157
											],
											[
												18.832,
												-31.522
											],
											[
												51.16,
												-31.522
											],
											[
												51.16,
												-39.679
											],
											[
												18.832,
												-39.679
											],
											[
												18.832,
												-62.338
											],
											[
												54.684,
												-62.338
											],
											[
												54.684,
												-70.496
											],
											[
												9.769,
												-70.496
											],
											[
												9.769,
												0
											]
										],
										"c": true
									}
								},
								"nm": "E",
								"hd": false
							}
						],
						"nm": "E",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "d",
			"size": 17,
			"style": "Regular",
			"w": 60.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												7.05,
												0
											],
											[
												0,
												-15.912
											],
											[
												-13.394,
												0
											],
											[
												-3.726,
												5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.827,
												-5.338
											],
											[
												-13.596,
												0
											],
											[
												0,
												16.415
											],
											[
												6.747,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												43.607,
												-43.808
											],
											[
												27.393,
												-51.562
											],
											[
												4.532,
												-25.177
											],
											[
												27.695,
												1.208
											],
											[
												43.607,
												-7.352
											],
											[
												43.607,
												0
											],
											[
												52.67,
												0
											],
											[
												52.67,
												-70.496
											],
											[
												43.607,
												-70.496
											]
										],
										"c": true
									}
								},
								"nm": "d",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												2.82,
												-3.223
											],
											[
												4.431,
												0
											],
											[
												0,
												11.783
											],
											[
												-2.518,
												3.323
											],
											[
												-5.64,
												0
											],
											[
												0,
												-9.366
											]
										],
										"o": [
											[
												-2.417,
												2.719
											],
											[
												-11.783,
												0
											],
											[
												0,
												-6.143
											],
											[
												2.316,
												-3.122
											],
											[
												12.286,
												0
											],
											[
												0,
												6.747
											]
										],
										"v": [
											[
												39.578,
												-10.071
											],
											[
												29.306,
												-5.942
											],
											[
												14.502,
												-25.177
											],
											[
												17.926,
												-39.478
											],
											[
												29.507,
												-44.312
											],
											[
												43.909,
												-25.076
											]
										],
										"c": true
									}
								},
								"nm": "d",
								"hd": false
							}
						],
						"nm": "d",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "i",
			"size": 17,
			"style": "Regular",
			"w": 42.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												16.617,
												-70.596
											],
											[
												16.617,
												-59.72
											],
											[
												25.882,
												-59.72
											],
											[
												25.882,
												-70.596
											]
										],
										"c": true
									}
								},
								"nm": "i",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.285,
												-50.354
											],
											[
												8.661,
												-50.354
											],
											[
												8.661,
												-42.7
											],
											[
												17.221,
												-42.7
											],
											[
												17.221,
												-7.654
											],
											[
												7.15,
												-7.654
											],
											[
												7.15,
												0
											],
											[
												35.449,
												0
											],
											[
												35.449,
												-7.654
											],
											[
												26.285,
												-7.654
											]
										],
										"c": true
									}
								},
								"nm": "i",
								"hd": false
							}
						],
						"nm": "i",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "t",
			"size": 17,
			"style": "Regular",
			"w": 46.4,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-10.876,
												0
											],
											[
												-1.913,
												0.504
											],
											[
												0,
												0
											],
											[
												1.913,
												0
											],
											[
												0,
												4.028
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												2.618,
												0
											],
											[
												0,
												0
											],
											[
												-2.014,
												0.504
											],
											[
												-5.438,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.164
											]
										],
										"v": [
											[
												32.025,
												0.504
											],
											[
												39.478,
												-0.302
											],
											[
												39.276,
												-8.56
											],
											[
												32.73,
												-7.654
											],
											[
												25.378,
												-12.689
											],
											[
												25.378,
												-42.801
											],
											[
												39.679,
												-42.801
											],
											[
												39.679,
												-50.354
											],
											[
												25.378,
												-50.354
											],
											[
												25.378,
												-64.352
											],
											[
												16.415,
												-64.352
											],
											[
												16.415,
												-50.354
											],
											[
												5.841,
												-50.354
											],
											[
												5.841,
												-42.801
											],
											[
												16.415,
												-42.801
											],
											[
												16.415,
												-12.387
											]
										],
										"c": true
									}
								},
								"nm": "t",
								"hd": false
							}
						],
						"nm": "t",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "o",
			"size": 17,
			"style": "Regular",
			"w": 59.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.71,
												0
											],
											[
												0,
												15.811
											],
											[
												15.408,
												0
											],
											[
												0,
												-15.308
											]
										],
										"o": [
											[
												15.106,
												0
											],
											[
												0,
												-15.207
											],
											[
												-15.61,
												0
											],
											[
												0,
												16.415
											]
										],
										"v": [
											[
												30.112,
												1.208
											],
											[
												55.188,
												-25.177
											],
											[
												30.112,
												-51.562
											],
											[
												4.935,
												-25.177
											]
										],
										"c": true
									}
								},
								"nm": "o",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												5.136,
												0
											],
											[
												2.417,
												2.518
											],
											[
												0,
												6.747
											],
											[
												-3.223,
												3.323
											],
											[
												-4.935,
												0
											],
											[
												-2.417,
												-2.618
											],
											[
												0,
												-6.546
											],
											[
												2.921,
												-3.323
											]
										],
										"o": [
											[
												-5.035,
												0
											],
											[
												-3.223,
												-3.323
											],
											[
												0,
												-6.747
											],
											[
												2.417,
												-2.518
											],
											[
												5.136,
												0
											],
											[
												3.021,
												3.323
											],
											[
												0,
												6.546
											],
											[
												-2.417,
												2.719
											]
										],
										"v": [
											[
												30.112,
												-5.942
											],
											[
												19.135,
												-9.769
											],
											[
												14.703,
												-25.177
											],
											[
												19.135,
												-40.585
											],
											[
												30.112,
												-44.412
											],
											[
												41.19,
												-40.283
											],
											[
												45.419,
												-25.177
											],
											[
												41.29,
												-10.172
											]
										],
										"c": true
									}
								},
								"nm": "o",
								"hd": false
							}
						],
						"nm": "o",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "r",
			"size": 17,
			"style": "Regular",
			"w": 48.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0.906,
												-0.101
											],
											[
												1.913,
												-5.64
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-10.373,
												0
											],
											[
												-0.806,
												-0.101
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-8.862,
												0.806
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-16.617
											],
											[
												1.108,
												0
											],
											[
												0,
												0
											],
											[
												-0.906,
												0
											]
										],
										"v": [
											[
												39.377,
												-51.462
											],
											[
												21.652,
												-40.887
											],
											[
												21.652,
												-50.354
											],
											[
												12.589,
												-50.354
											],
											[
												12.589,
												0
											],
											[
												21.652,
												0
											],
											[
												21.652,
												-23.062
											],
											[
												40.182,
												-43.103
											],
											[
												43.304,
												-43.002
											],
											[
												43.506,
												-51.562
											]
										],
										"c": true
									}
								},
								"nm": "r",
								"hd": false
							}
						],
						"nm": "r",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "a",
			"size": 17,
			"style": "Regular",
			"w": 58,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0.806,
												0
											],
											[
												0,
												2.618
											],
											[
												0,
												0
											],
											[
												12.689,
												0
											],
											[
												3.625,
												-2.417
											],
											[
												0.201,
												-6.042
											],
											[
												0,
												0
											],
											[
												-8.762,
												0
											],
											[
												-1.41,
												-2.014
											],
											[
												0,
												-4.532
											],
											[
												0,
												0
											],
											[
												0,
												-10.876
											],
											[
												-8.459,
												0
											],
											[
												-2.82,
												5.74
											],
											[
												-5.539,
												0
											],
											[
												-1.913,
												0.302
											]
										],
										"o": [
											[
												-1.309,
												0.302
											],
											[
												-2.921,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-10.977
											],
											[
												-6.445,
												0
											],
											[
												-3.928,
												2.618
											],
											[
												0,
												0
											],
											[
												0,
												-7.654
											],
											[
												4.431,
												0
											],
											[
												1.511,
												2.115
											],
											[
												0,
												0
											],
											[
												-7.956,
												1.511
											],
											[
												0,
												9.869
											],
											[
												8.56,
												0
											],
											[
												0.504,
												5.237
											],
											[
												2.014,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												54.886,
												-7.452
											],
											[
												51.965,
												-7.05
											],
											[
												49.045,
												-10.876
											],
											[
												49.045,
												-34.946
											],
											[
												29.91,
												-51.562
											],
											[
												14.502,
												-47.836
											],
											[
												8.258,
												-34.744
											],
											[
												17.12,
												-33.536
											],
											[
												29.407,
												-44.412
											],
											[
												38.571,
												-41.089
											],
											[
												40.283,
												-31.924
											],
											[
												23.666,
												-28.702
											],
											[
												6.546,
												-13.293
											],
											[
												23.465,
												1.208
											],
											[
												40.384,
												-7.452
											],
											[
												49.448,
												0.403
											],
											[
												55.087,
												0
											]
										],
										"c": true
									}
								},
								"nm": "a",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												10.977,
												0
											],
											[
												0,
												4.733
											],
											[
												-5.338,
												1.208
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-4.935,
												0
											],
											[
												0,
												-5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												7.251
											]
										],
										"v": [
											[
												24.875,
												-6.042
											],
											[
												15.811,
												-13.394
											],
											[
												25.076,
												-21.854
											],
											[
												40.283,
												-25.177
											],
											[
												40.283,
												-19.034
											]
										],
										"c": true
									}
								},
								"nm": "a",
								"hd": false
							}
						],
						"nm": "a",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "l",
			"size": 17,
			"style": "Regular",
			"w": 42.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.486,
												-70.496
											],
											[
												9.064,
												-70.496
											],
											[
												9.064,
												-62.842
											],
											[
												17.422,
												-62.842
											],
											[
												17.422,
												-7.654
											],
											[
												7.352,
												-7.654
											],
											[
												7.352,
												0
											],
											[
												35.651,
												0
											],
											[
												35.651,
												-7.654
											],
											[
												26.486,
												-7.654
											]
										],
										"c": true
									}
								},
								"nm": "l",
								"hd": false
							}
						],
						"nm": "l",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": " ",
			"size": 17,
			"style": "Regular",
			"w": 42.2,
			"data": {},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "c",
			"size": 17,
			"style": "Regular",
			"w": 57.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.408,
												0
											],
											[
												-1.813,
												10.172
											],
											[
												0,
												0
											],
											[
												7.755,
												0
											],
											[
												0,
												11.38
											],
											[
												-2.518,
												3.424
											],
											[
												-5.74,
												0
											],
											[
												-1.511,
												-5.841
											],
											[
												0,
												0
											],
											[
												12.79,
												0
											],
											[
												0,
												-15.509
											]
										],
										"o": [
											[
												11.682,
												0
											],
											[
												0,
												0
											],
											[
												-1.913,
												7.251
											],
											[
												-12.186,
												0
											],
											[
												0,
												-5.942
											],
											[
												2.316,
												-3.021
											],
											[
												9.064,
												0
											],
											[
												0,
												0
											],
											[
												-2.014,
												-9.567
											],
											[
												-15.408,
												0
											],
											[
												0,
												16.516
											]
										],
										"v": [
											[
												30.917,
												1.208
											],
											[
												53.174,
												-15.408
											],
											[
												44.614,
												-16.315
											],
											[
												30.917,
												-6.042
											],
											[
												15.912,
												-25.177
											],
											[
												19.235,
												-39.578
											],
											[
												30.917,
												-44.312
											],
											[
												44.513,
												-32.73
											],
											[
												52.972,
												-34.341
											],
											[
												30.917,
												-51.562
											],
											[
												5.942,
												-25.177
											]
										],
										"c": true
									}
								},
								"nm": "c",
								"hd": false
							}
						],
						"nm": "c",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "n",
			"size": 17,
			"style": "Regular",
			"w": 59,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.928,
												4.129
											],
											[
												6.647,
												0
											],
											[
												2.518,
												-5.64
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.431,
												0
											],
											[
												-2.82,
												-2.82
											],
											[
												0,
												-4.633
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.625,
												-3.827
											],
											[
												-8.057,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-14.401
											],
											[
												2.82,
												0
											],
											[
												3.122,
												2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-4.935
											]
										],
										"v": [
											[
												47.937,
												-45.923
											],
											[
												32.932,
												-51.562
											],
											[
												17.422,
												-42.7
											],
											[
												17.422,
												-50.354
											],
											[
												8.359,
												-50.354
											],
											[
												8.359,
												0
											],
											[
												17.422,
												0
											],
											[
												17.422,
												-27.795
											],
											[
												30.515,
												-44.009
											],
											[
												39.478,
												-41.089
											],
											[
												42.499,
												-29.407
											],
											[
												42.499,
												0
											],
											[
												51.865,
												0
											],
											[
												51.865,
												-29.91
											]
										],
										"c": true
									}
								},
								"nm": "n",
								"hd": false
							}
						],
						"nm": "n",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "e",
			"size": 17,
			"style": "Regular",
			"w": 58.5,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.021,
												4.834
											],
											[
												7.956,
												0
											],
											[
												4.431,
												-5.035
											],
											[
												0,
												-7.452
											],
											[
												-4.23,
												-4.733
											],
											[
												-7.755,
												0
											],
											[
												-2.216,
												11.783
											],
											[
												0,
												0
											],
											[
												8.56,
												0
											],
											[
												0.201,
												11.078
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-4.129,
												-6.546
											],
											[
												-7.251,
												0
											],
											[
												-4.23,
												4.733
											],
											[
												0,
												7.855
											],
											[
												4.33,
												5.035
											],
											[
												12.79,
												0
											],
											[
												0,
												0
											],
											[
												-1.208,
												7.654
											],
											[
												-9.467,
												0
											],
											[
												0,
												0
											],
											[
												0.403,
												-7.15
											]
										],
										"v": [
											[
												49.347,
												-41.592
											],
											[
												29.709,
												-51.562
											],
											[
												11.884,
												-44.009
											],
											[
												5.539,
												-25.278
											],
											[
												11.682,
												-6.143
											],
											[
												29.81,
												1.208
											],
											[
												52.872,
												-16.617
											],
											[
												44.11,
												-17.322
											],
											[
												29.709,
												-6.042
											],
											[
												15.408,
												-22.458
											],
											[
												53.577,
												-22.458
											]
										],
										"c": true
									}
								},
								"nm": "e",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-5.64,
												0
											],
											[
												-2.618,
												-3.827
											],
											[
												-0.101,
												-2.719
											],
											[
												0,
												0
											],
											[
												-1.813,
												3.021
											]
										],
										"o": [
											[
												5.438,
												0
											],
											[
												1.611,
												2.417
											],
											[
												0,
												0
											],
											[
												0,
												-2.518
											],
											[
												2.014,
												-3.323
											]
										],
										"v": [
											[
												29.81,
												-44.211
											],
											[
												41.592,
												-38.773
											],
											[
												44.312,
												-29.81
											],
											[
												15.509,
												-29.81
											],
											[
												17.926,
												-38.773
											]
										],
										"c": true
									}
								},
								"nm": "e",
								"hd": false
							}
						],
						"nm": "e",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "T",
			"size": 17,
			"style": "Regular",
			"w": 60.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												34.644,
												0
											],
											[
												34.644,
												-62.54
											],
											[
												57.202,
												-62.54
											],
											[
												57.202,
												-70.496
											],
											[
												2.921,
												-70.496
											],
											[
												2.921,
												-62.54
											],
											[
												25.479,
												-62.54
											],
											[
												25.479,
												0
											]
										],
										"c": true
									}
								},
								"nm": "T",
								"hd": false
							}
						],
						"nm": "T",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "h",
			"size": 17,
			"style": "Regular",
			"w": 59,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.928,
												4.129
											],
											[
												6.647,
												0
											],
											[
												2.82,
												-6.042
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.532,
												0
											],
											[
												-2.82,
												-2.82
											],
											[
												0,
												-4.633
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.625,
												-3.827
											],
											[
												-7.05,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-14.603
											],
											[
												2.82,
												0
											],
											[
												3.122,
												2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-4.834
											]
										],
										"v": [
											[
												47.937,
												-45.923
											],
											[
												32.932,
												-51.562
											],
											[
												17.422,
												-42.801
											],
											[
												17.422,
												-70.496
											],
											[
												8.359,
												-70.496
											],
											[
												8.359,
												0
											],
											[
												17.422,
												0
											],
											[
												17.422,
												-28.299
											],
											[
												30.515,
												-44.009
											],
											[
												39.478,
												-41.089
											],
											[
												42.499,
												-29.608
											],
											[
												42.499,
												0
											],
											[
												51.865,
												0
											],
											[
												51.865,
												-30.112
											]
										],
										"c": true
									}
								},
								"nm": "h",
								"hd": false
							}
						],
						"nm": "h",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "S",
			"size": 17,
			"style": "Regular",
			"w": 63,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.106,
												0
											],
											[
												0,
												17.12
											],
											[
												13.495,
												2.316
											],
											[
												0,
												8.057
											],
											[
												-7.452,
												0
											],
											[
												-0.403,
												-10.172
											],
											[
												0,
												0
											],
											[
												13.898,
												0
											],
											[
												0,
												-14.301
											],
											[
												-10.574,
												-2.518
											],
											[
												0,
												-9.769
											],
											[
												9.567,
												0
											],
											[
												0.302,
												10.977
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												12.891,
												0
											],
											[
												0,
												-14.804
											],
											[
												-9.164,
												-1.611
											],
											[
												0,
												-7.956
											],
											[
												10.574,
												0
											],
											[
												0,
												0
											],
											[
												-1.611,
												-16.315
											],
											[
												-11.279,
												0
											],
											[
												0,
												13.293
											],
											[
												10.172,
												2.518
											],
											[
												0,
												9.97
											],
											[
												-10.474,
												0
											],
											[
												0,
												0
											],
											[
												0.302,
												16.113
											]
										],
										"v": [
											[
												32.529,
												1.208
											],
											[
												59.72,
												-20.544
											],
											[
												34.744,
												-40.283
											],
											[
												15.408,
												-52.267
											],
											[
												30.515,
												-64.151
											],
											[
												48.038,
												-48.038
											],
											[
												57.504,
												-49.75
											],
											[
												30.414,
												-71.704
											],
											[
												6.042,
												-51.865
											],
											[
												28.198,
												-32.025
											],
											[
												50.253,
												-19.839
											],
											[
												32.227,
												-6.445
											],
											[
												13.696,
												-23.465
											],
											[
												4.028,
												-22.458
											]
										],
										"c": true
									}
								},
								"nm": "S",
								"hd": false
							}
						],
						"nm": "S",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "p",
			"size": 17,
			"style": "Regular",
			"w": 60.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												13.394,
												0
											],
											[
												3.726,
												-5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-7.05,
												0
											],
											[
												0,
												15.912
											]
										],
										"o": [
											[
												-6.747,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												3.827,
												5.338
											],
											[
												13.596,
												0
											],
											[
												0,
												-16.415
											]
										],
										"v": [
											[
												33.133,
												-51.562
											],
											[
												17.221,
												-43.002
											],
											[
												17.221,
												-50.354
											],
											[
												8.157,
												-50.354
											],
											[
												8.157,
												20.142
											],
											[
												17.221,
												20.142
											],
											[
												17.221,
												-6.546
											],
											[
												33.435,
												1.208
											],
											[
												56.296,
												-25.177
											]
										],
										"c": true
									}
								},
								"nm": "p",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												2.82,
												-3.122
											],
											[
												5.136,
												0
											],
											[
												0,
												9.366
											],
											[
												-2.618,
												3.223
											],
											[
												-4.633,
												0
											],
											[
												0,
												-11.783
											]
										],
										"o": [
											[
												-2.316,
												2.82
											],
											[
												-12.286,
												0
											],
											[
												0,
												-6.546
											],
											[
												2.417,
												-3.021
											],
											[
												11.783,
												0
											],
											[
												0,
												6.445
											]
										],
										"v": [
											[
												42.398,
												-10.373
											],
											[
												31.32,
												-6.042
											],
											[
												16.919,
												-25.278
											],
											[
												20.847,
												-39.88
											],
											[
												31.522,
												-44.412
											],
											[
												46.326,
												-25.177
											]
										],
										"c": true
									}
								},
								"nm": "p",
								"hd": false
							}
						],
						"nm": "p",
						"bm": 0,
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/ShopVsEditorial.json
// module id = 61
// module chunks = 0